import { useSelector } from "react-redux";
import PreviewRow from "./PreviewRow";

const PreviewTable = ()=>{
  const bookings = useSelector(state=> state.bookings)

  return (
    <div className="table-container">
      {bookings?.length ? 
      <table className="booking-table">
        <thead className="bg-gray-100/50">
          <tr className="text-black text-left">
            <th>Destination From</th>
            <th>Destination To</th>
            <th className="text-center">Journey Date</th>
            <th className="text-center">Guests</th>
            <th className="text-center">Class</th>
            <th className="text-center">Delete</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
          {bookings?.map((item,index)=>(
            <PreviewRow data={item} key={index} index={index}/>
          ))}
        </tbody>
      </table>
      : null}
    </div>
  )
}

export default PreviewTable;